<template>
    <div class="shop-filter-range">
        <div class="shop-filter-price-row">
            <div class="shop-filter-field">
                <label class="shop-filter-label">{{ $trans('main2.From') }}</label>
                <el-select
                    v-if="hasOptions"
                    v-model="minValue"
                    :placeholder="$trans('main2.From')"
                    clearable
                    size="medium"
                    class="shop-filter-el-select"
                >
                    <el-option
                        v-for="option in sortedOptions"
                        :key="'min-' + option.id"
                        :label="option.title"
                        :value="optionNumericValue(option.title)"
                    />
                </el-select>
                <input
                    v-else
                    v-model.number="minValue"
                    type="number"
                    min="0"
                    :placeholder="$trans('main2.From')"
                    class="shop-filter-input"
                >
            </div>
            <div class="shop-filter-field">
                <label class="shop-filter-label">{{ $trans('main2.To') }}</label>
                <el-select
                    v-if="hasOptions"
                    v-model="maxValue"
                    :placeholder="$trans('main2.To')"
                    clearable
                    size="medium"
                    class="shop-filter-el-select"
                >
                    <el-option
                        v-for="option in sortedOptions"
                        :key="'max-' + option.id"
                        :label="option.title"
                        :value="optionNumericValue(option.title)"
                    />
                </el-select>
                <input
                    v-else
                    v-model.number="maxValue"
                    type="number"
                    min="0"
                    :placeholder="$trans('main2.To')"
                    class="shop-filter-input"
                >
            </div>
        </div>
        <div class="shop-filter-actions">
            <button
                type="button"
                class="btn btn-sm btn-outline-primary"
                @click="applyRangeFilter"
            >
                {{ $trans('main.Filter') }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormFieldRangeFilter',
    props: {
        formField: {
            required: true,
            type: Object,
        },
        onChangeHandler: {
            required: true,
            type: Function,
        },
    },
    data() {
        return {
            minValue: undefined,
            maxValue: undefined,
        };
    },
    computed: {
        hasOptions() {
            return ['dropdown', 'radio'].includes(this.formField.type)
                && (this.formField.options?.length ?? 0) > 0;
        },
        sortedOptions() {
            return [...(this.formField.options ?? [])].sort(
                (left, right) => this.optionNumericValue(left.title) - this.optionNumericValue(right.title)
            );
        },
        minKey() {
            return `additional_data_min[${this.formField.slug}]`;
        },
        maxKey() {
            return `additional_data_max[${this.formField.slug}]`;
        },
    },
    mounted() {
        this.syncFromUrl();
    },
    watch: {
        formField() {
            this.syncFromUrl();
        },
    },
    methods: {
        optionNumericValue(title) {
            const normalized = String(title).replace('+', '').trim();

            return Number(normalized);
        },
        syncFromUrl() {
            const filters = this.selectedFilters;
            this.minValue = this.readNumericFilter(filters[this.minKey]);
            this.maxValue = this.readNumericFilter(filters[this.maxKey]);
        },
        readNumericFilter(value) {
            if (value === undefined || value === null || value === '') {
                return undefined;
            }

            const parsed = Number(value);

            if (Number.isNaN(parsed) || this.isLegacySentinelValue(parsed)) {
                return undefined;
            }

            return parsed;
        },
        isLegacySentinelValue(value) {
            return Number(value) >= 9999999;
        },
        applyRangeFilter() {
            let min = this.normalizeValue(this.minValue);
            let max = this.normalizeValue(this.maxValue);

            if (min !== null && max !== null && min > max) {
                [min, max] = [max, min];
                this.minValue = min;
                this.maxValue = max;
            }

            this.onChangeHandler(`additional_data[${this.formField.slug}]`, null, false);
            this.onChangeHandler(`additional_data[${this.formField.slug}_option_id]`, null, false);
            this.onChangeHandler(this.minKey, min, false);
            this.onChangeHandler(this.maxKey, max, true);
        },
        normalizeValue(value) {
            if (value === undefined || value === null || value === '') {
                return null;
            }

            return value;
        },
    },
};
</script>
